var _path, _path2, _path3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.079 52H202.92C211.235 52 218 58.772 218 67.094v12.095A9.353 9.353 0 00213.43 78h-5.483V67.094a5.03 5.03 0 00-5.026-5.031H42.079a5.03 5.03 0 00-5.026 5.03V167.72a5.03 5.03 0 005.026 5.031H153v10.062h-25.474v20.126h35.185a5.03 5.03 0 015.026 5.031 5.03 5.03 0 01-5.026 5.031H82.289a5.03 5.03 0 01-5.026-5.031 5.03 5.03 0 015.026-5.031h35.185v-20.126H42.079c-8.314 0-15.079-6.772-15.079-15.093V67.094C27 58.772 33.765 52 42.079 52z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M213.43 78h-50.859c-5.277 0-9.571 4.387-9.571 9.778v98.444c0 5.391 4.294 9.778 9.571 9.778h50.859c5.277 0 9.57-4.387 9.57-9.778V87.777c0-5.39-4.293-9.777-9.57-9.777zm2.453 108.222c0 1.383-1.101 2.508-2.453 2.508h-50.859c-1.353 0-2.454-1.125-2.454-2.508V87.777c0-1.382 1.101-2.506 2.454-2.506h8.757c.298 2.506 2.387 4.449 4.92 4.449h23.502c2.537 0 4.623-1.943 4.92-4.45h8.76c1.353 0 2.454 1.125 2.454 2.508l-.001 98.444zM86.521 111.185L56 129.61v-6.032l24.482-14.65L56 93.909V88l30.521 18.261v4.924zM142 146.636H91.853v-5.375H142v5.375z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M200.031 161H177v-44.094h22.844v4.469h-17.719v13.656h17.031v4.469h-17.031v17.031h17.906V161z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f8357f7836afd728b8f2c3e436a4d091.svg";
export { ForwardRef as ReactComponent };